import additionalList from './additionalList';
import additionalListSingle from './additionalListSingle';
import additionalSave from './additionalSave';

export default {
    additionalList,
    additionalListSingle,
    additionalSave,
};



// WEBPACK FOOTER //
// ./src/api/invoiceInformation/index.ts